



















































import { MrfiktivPartialAddressWithGeoViewModelGen } from "@/services/mrfiktiv/v1/data-contracts";
import { Component, Prop, Vue } from "vue-property-decorator";
import { VSkeletonLoader } from "vuetify/lib";

const PartnerMap = () => ({
  component: import(/* webpackPrefetch: true  */ /* webpackChunkName: "map" */ "@/components/form/PartnerMap.vue"),
  loading: VSkeletonLoader
});

@Component({
  components: {
    PartnerMap
  }
})
export default class PartnerReportMapAddress extends Vue {
  @Prop() value!: MrfiktivPartialAddressWithGeoViewModelGen;
}
